import {useContext, useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import config from "../../Requests/RequestConfig.json";
import imageNotFound from "../../Assets/Images/image-not-found.png";
import {CartContext} from "../../Contexts/CartContext";
import {toLower} from "lodash";
import {ChannelContext} from "../../Contexts/ChannelContext";

function normalizeEan(value){
    if (value === null || value === undefined){
        return null;
    }

    const ean = String(value).trim();

    return ean === '' ? null : ean;
}

function useProductData(data){
    const calculatedInputRef    = useRef(null);
    const defaultImage          = imageNotFound;
    const {t}                   = useTranslation();
    const channel         = useContext(ChannelContext);

    let thumb, bigThumb;
    let images = [];

    if (data === null){
        return null;
    }

    thumb = (data.thumb === null ? defaultImage : config.domain+'/assets/img/thumbnail/'+data.thumb);
    bigThumb = (data.thumb === null ? defaultImage : config.domain+'/assets/img/'+data.thumb);

    let isGallery;
    if (data.gallery?.length > 0){
        isGallery = true;
        images = data.gallery.map((value) => {
            return config.domain+'/assets/img/'+value;
        });
    } else {
        isGallery = false;
        images.push(defaultImage);
    }

    if (thumb === defaultImage && data.gallery?.length > 0){
        thumb = config.domain+'/assets/img/thumbnail/'+data.gallery[0];
        bigThumb = config.domain+'/assets/img/'+data.gallery[0];
    }

    let totalNetto, totalBrutto;

    if (data.price === null){
        totalBrutto = 0;
        totalNetto = 0;
        data.price = {};
        data.price.isPromoted = false;
        data.price.priceBeforeDiscountNetto = 0;
        data.price.priceBeforeDiscountBrutto = 0;
        data.price.priceAfterDiscountNetto = 0;
        data.price.priceAfterDiscountBrutto = 0;
        data.price.discount = 0;
        data.price.priceType = '';

    } else {

        let finalPriceNetto, finalPriceBrutto, quantityInPackage;

        if (data.price.priceAfterDiscountNetto > 0){
            finalPriceNetto = data.price.priceAfterDiscountNetto;
            finalPriceBrutto = data.price.priceAfterDiscountBrutto;
        } else {
            finalPriceNetto = data.price.priceBeforeDiscountNetto;
            finalPriceBrutto = data.price.priceBeforeDiscountBrutto;
        }

        if (channel.IncompletePackaging && !channel.products.some(product => product.id === data.id)){
            quantityInPackage = 1;
        } else {
            quantityInPackage = data.quantityInPackage;
        }

        totalNetto = (data.cartItemQuantity * quantityInPackage) * parseFloat(finalPriceNetto);
        totalBrutto = (data.cartItemQuantity * quantityInPackage) * parseFloat(finalPriceBrutto);


    }

    const eans = Array.isArray(data.eans) ? data.eans : [];
    const defaultEan = normalizeEan(data["default_ean"]);
    const ean = defaultEan || eans.map(normalizeEan).find(Boolean) || null;
    const alternativeEans = eans
        .map(normalizeEan)
        .filter(value => value !== null && value !== ean);

    let promotion = false;

    if (data.price && (data.price.isPromoted || data.price.isUglyPromotion)){
        promotion = true;
    }

    return {
        id: data.id,
        name: (data.translation.name || data.hurtName),
        description: data.translation.description,
        slug: data.slug,
        indexHurt: data.hurtId,
        eans: alternativeEans.join(', ') || null,
        ean,
        unit: t('products-list.'+toLower(data.unit)),
        quantityUnit: data.saleDepartmentSum + ' ' + t('products-list.'+toLower(data.unit)),
        quantity: data.saleDepartmentSum,
        quantityPackage: data.quantityInPackage,
        moqHurt: Number(data.moq_hurt || 0),
        moqShop: Number(data.moq_shop || 0),
        isSales: data.isSale,
        massive: data.isMassive,
        isNew: data.isNew,
        producerIndex: data["producer_index"],
        show_supplier_code: data.brand.show_supplier_code,
        notFullPacking: data.notFullPacking,
        isNoDiscount: data.isNoDiscount,

        promoted: promotion,
        priceBefore: parseFloat(data.price.priceBeforeDiscountNetto),
        priceBeforeBrutto: parseFloat(data.price.priceBeforeDiscountBrutto),
        priceNetto: parseFloat(data.price.priceAfterDiscountNetto),
        priceBrutto: parseFloat(data.price.priceAfterDiscountBrutto),
        discount: data.price.discount,
        promotionType: data.price.priceType,
        offerItemId: (data.price.hasOwnProperty('offerItemId') ? data.price.offerItemId : null),

        thumb,
        bigThumb,
        images,
        isGallery,

        ref: calculatedInputRef,

        producerName: data.producer.name,
        brandName: data.brand.name,
        licenseName: (data.license !== null ? data.license.name : '-'),

        cartItemQuantity: data.cartItemQuantity,
        totalNetto: parseFloat(totalNetto.toFixed(2)),
        totalBrutto: parseFloat(totalBrutto.toFixed(2)),
    };
}


export {useProductData};
